<template>
  <div class="home">
    <BigSlide :height="slideHeight" :BannerList="BannerList" :lang="lang" />
    <div class="wrap hotW" :class="{ titleEn: lang == 'en' }" >
      <div class="pageTitle wow animate__slideInUp">
        <h2>新闻中心</h2>
        <p>NEWS CENTER</p>
      </div>

      <div class="newsW">
        <div class="media homeMedia">
          <div class="mediaFigure homeH wow animate__slideInUp">
            <HomeHot :TopNews="TopNews" :lang="lang" />
          </div>
          <div class="mediaBody wow animate__slideInUp">
            <HomeList :News="News" />
          </div>
        </div>
      </div>

      <!-- <el-tabs v-model="activeName" type="card" class="myTabs">
        <el-tab-pane label="公司动态" name="first">
          <div class="media">
            <div class="mediaFigure"><HomeHot /></div>
            <div class="mediaBody"><HomeList /></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="文化中心" name="second">配置管理</el-tab-pane>
      </el-tabs> -->
    </div>
    <div class="wrap cardSlideBox one wow animate__slideInUp">
      <div ref="one" class="pageTitle" :class="{ titleEn: lang == 'en' }">
        <h2>应用领域</h2>
        <p>APPLICATION</p>
      </div>
      <div class="cardBox">
        <CardSelfSlide :ApplicationAreas="ApplicationAreas" />
      </div>
    </div>

    <div class="productBox">
      <div
        class="pageTitle wow animate__slideInUp"
        :class="{ titleEn: lang == 'en' }"
      >
        <h2>产品介绍</h2>
        <p>PRODUCT</p>
      </div>
      <div class="wrap">
        <ProductSection :Product="Product" :RdCore="RdCore" :lang="lang" />
      </div>
    </div>

    <div class="productBox" v-if="lang != 'en'">
      <div class="pageTitle wow animate__slideInUp">
        <h2>党的建设</h2>
        <p>PARTY BUILDING</p>
      </div>
      <div class="wrap homeParty wow animate__slideInUp">
        <HomeList :News="NewsOfParty" />
        <el-image
          fit="cover"
          class="homeImg"
          :src="PartyBuildingPic"
        ></el-image>
      </div>
      <div class="homeBtn wow animate__slideInUp">
        <router-link to="/party/important"
          ><span class="bigMore greyBtn">了解更多</span></router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import BigSlide from "./components/BigSlide.vue";
import CardSelfSlide from "./components/CardSelfSlide.vue";
import ProductSection from "./components/ProductSection.vue";
import HomeList from "./components/HomeList.vue";
import HomeHot from "./components/HomeHot.vue";
import { WOW } from "wowjs";
import cookie from "cookiejs";

export default {
  name: "home",
  data() {
    return {
      fullscreenLoading: true,
      slideHeight: document.documentElement.clientHeight - 60,
      activeName: "first",
      animate: false,
      classObject: {
        animate__animated: this.animate,
        animate__flipInX: this.animate,
      },
      oneStart: false,
      twoStart: false,
      newsNav: [
        "公司动态",
        "文化活动",
        "视频新闻",
        "行业动态",
        "信息公示",
        "企业内刊",
      ],
      newsOn: "0",
      indexData: {},
      BannerList: {},
      ApplicationAreas: [],
      Product: { PicUrl: "" },
      RdCore: { PicUrl: "" },
      TopNews: [],
      News: [],
      NewsOfParty: [],
      PartyBuildingPic: "",
      lang: "zh",
	  isShow:true,
    };
  },
  components: {
    BigSlide,
    CardSelfSlide,
    ProductSection,
    HomeList,
    HomeHot,
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let one = this.$refs.one.offsetTop;
      if (scrollTop >= 0 && !this.oneStart) {
        // this.animate = true;
        // this.$refs.one.style({visibility:})
        // animateCSS('.one','slideInUp')
        // this.oneStart = true
        // this.twoStart = true
      }
    },
    newsTabFn(idx) {
      this.newsOn = idx;
    },
  },
  created() {
    this.lang = cookie.get("lang");
  },
  mounted() {
    const reloadJSON = sessionStorage.getItem("reload");
    if (reloadJSON) {
      sessionStorage.removeItem("reload");
      location.reload();
    }

    // window.addEventListener("scroll", this.handleScroll);

    // this.$api.test({ type: "NewsBannerPic", lan: "cn" });
    // this.fullscreenLoading = true;
    this.$api.index({}).then((res) => {
      const {
        BannerList,
        ApplicationAreas,
        Product,
        RdCore,
        TopNews,
        News,
        NewsOfParty,
        TopNewsList,
        PartyBuildingPic,
      } = res.Value;
      this.BannerList = BannerList;
      this.ApplicationAreas = ApplicationAreas;
      this.Product = Product;
      this.RdCore = RdCore;
      this.TopNews = TopNews;
      this.News = News;
      console.log(News, "1111");
      this.NewsOfParty = NewsOfParty;
      this.TopNews = TopNewsList;
      this.PartyBuildingPic = PartyBuildingPic;
      // this.fullscreenLoading = false;

      this.$nextTick(() => {
        new WOW({
          boxClass: "wow",
          animateClass: "animate__animated",
          offset: 100,
          live: false,
        }).init();
      });
    });
  },
};
</script>

<style lang="scss">
.cardSlideBox {
  .cardBox {
    padding: 50px 0;
  }
  // .pageTitle{visibility:hidden}
}
.productBox {
  background: #f9f9f9;
  overflow: hidden;
}
.hotW {
  padding-bottom: 20px;
}
.homeImg {
  width: 500px;
  margin-left: 50px;
  &:hover {
    animation: pulse;
    animation-duration: 1s;
  }
}
.homeParty {
  display: flex;
  justify-content: space-between;
  padding: 50px 0 50px;
}
.homeBtn {
  text-align: center;
  padding: 0 0 50px 0;
}
.one {
  visibility: hidden;
}
.homeH {
  overflow: hidden;
}
.media .mediaFigure {
  overflow: unset !important;
}
.newsW {
  padding-top: 50px;
}
@media screen and (max-width: 1000px) {
  .homeUl li {
    padding: 25px 0;
  }
}
</style>
